import { createSelector } from 'reselect';

export const normalized = createSelector(
  [state => state.entry, state => state.percentageWeightings],
  (entry, percentageWeightingsObject) => {
    let ret = {};
    (entry.compareMode ? ["original","proposed"] : ["original"]).forEach(side => {
      const weightings = entry[side].weightings;
      const percentageWeightings = percentageWeightingsObject[side];
      const sum =
        Object.keys(weightings).reduce((a, b) => a + weightings[b], 0) || 1;
      const normalized = { ...weightings };
      Object.keys(weightings).forEach(key => {
        normalized[key] = percentageWeightings[key] != null
          ? percentageWeightings[key]
          : weightings[key] / sum;
      });
      ret[side] = normalized;
    })
    return ret
  }
);

export const normalizedSum = createSelector(
  [state => state.entry.compareMode, normalized], 
  (compareMode, weightings) => {
    let ret = {};
    (compareMode ? ["original","proposed"] : ["original"]).forEach(side => {
      ret[side] = Object.keys(weightings[side]).reduce((a, b) => a + weightings[side][b], 0)
    })
    return ret
});


// WEBPACK FOOTER //
// ./src/selectors/normalized-weights.js